import axiosInstance from "./axiosConfig";

/**
 * Service for interacting with coupon usage API endpoints
 */
const couponUsageService = {
  /**
   * Get coupon usage records with pagination and filtering
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number
   * @param {number} params.limit - Items per page
   * @param {string} params.couponCode - Filter by coupon code
   * @param {string} params.userId - Filter by user ID
   * @param {string} params.orderId - Filter by order ID
   * @param {string} params.startDate - Filter by usage date (start date)
   * @param {string} params.endDate - Filter by usage date (end date)
   * @returns {Promise<Object>} - Paginated coupon usage data
   */
  getCouponUsages: async (params = {}) => {
    const response = await axiosInstance.get("/admin/coupon-usages", {
      params,
    });
    return response.data;
  },
};

export default couponUsageService;
